import { render } from "./IntroductionForm.vue?vue&type=template&id=cccda8e2&scoped=true"
import script from "./IntroductionForm.vue?vue&type=script&lang=js"
export * from "./IntroductionForm.vue?vue&type=script&lang=js"

import "./IntroductionForm.vue?vue&type=style&index=0&id=cccda8e2&lang=scss&scoped=true"

import exportComponent from "/Users/zsrb/Documents/中山日报/2025/zsrb-news-detail/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cccda8e2"]])

export default __exports__